import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LoadingProvider } from "./contexts/LoadingContext";
import { ModalProvider } from "./contexts/ModalContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterHOC } from "./routes";
import { I18nextProvider } from "react-i18next";
// import i18n (needs to be bundled ;))
import i18n from "./i18n";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <LoadingProvider>
            <ModalProvider>
              <RouterHOC />
              {/* Show DevTools in development - always show for now to debug */}
              <ReactQueryDevtools initialIsOpen={false} />
            </ModalProvider>
          </LoadingProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
